// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"5697a1be","318":"31c589d9","375":"bd9ff7bd","399":"b2f295e7","453":"7712f9a6","533":"43d1d29d","591":"b44d9811","678":"cd09fb2e","720":"8c0ed215","828":"351ef91b","845":"4149f839","982":"ece9bf33"}[chunkId] + ".chunk.js";
};